var KeyCode = require('./keycode');

module.exports = function(header) {
	var _t = this;
	
	this.classList.add('modal');

	var backdrop;

	var handleKeyUp = function(e) {
		var e = new KeyCode(e || window.event);
		if (e.code == 'Escape') {
			_t.close();
		}	
	};

	this.open = function(data) {
		if (_t.active) return;

		backdrop = document.createElement('div');
		backdrop.className = 'backdrop';
		backdrop.onclick = function(evt) {
			(evt || window.event).stopPropagation();
			_t.close();
			return false;
		};

		_t.parentNode.appendChild(backdrop);
		document.body.onkeyup = handleKeyUp;
		_t.active = true;
		refresh();
		on(_t, 'open').fire(data);
	};

	this.close = function(data) {
		if (!_t.active) return;

		document.body.onkeyup = null;
		
		backdrop?.parentNode?.removeChild(backdrop);
		_t.active = false;
		refresh();
		on(_t, 'close').fire(data);
	};

	var refresh = function() {
		if (_t.active) {
			_t.classList.add('active');
		} else {
			_t.classList.remove('active');
		}
	};


};
